import { render } from "./VideoGroup.vue?vue&type=template&id=c02ada40&scoped=true"
import script from "./VideoGroup.vue?vue&type=script&lang=js"
export * from "./VideoGroup.vue?vue&type=script&lang=js"

import "./VideoGroup.vue?vue&type=style&index=0&id=c02ada40&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02ada40"]])

export default __exports__